// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


const lightbox = GLightbox({
    videosWidth: "100vw",
     autoplayVideos: true,
      // touchNavigation: false,
    plyr: {
        config: {
            ratio: "3:4"
        }
    }
});


$( document ).ready(function() {

      const searchbox = GLightbox({
          /*touchNavigation: false,
          touchFollowAxis: false,
          keyboardNavigation: false,*/
          selector: ".searchboxlink",
          zoomable: false,
          draggable: false,
          // width: '60vw',
          height: 'auto',
      });


      searchbox.on('open', () => {
          $('.button--close').click(function(){
              searchbox.close();
          })
    });


});
